import React, { useEffect, useState } from 'react';
import useDataLoader2 from '../../hooks/useDataLoader2';
import CatalogTableC from '../../components/Catalogs/CatalogTableC';
import { UseFirmList } from '../../hooks/Catalogs/useFirm';
import PaginatedTable from '../../components/Organismos/Table/PaginatedTable';
import ShapeEdit from '../../components/Atomos/Icons/ShapeEdit';
import { defaultPageSize } from '../../utils/const';
import Filters, { IFilterData } from '../../components/Catalogs/Filters/Filters';
import PersistentLink from '../../components/Moleculas/PersistentLink';
import { formatTimeSpanToString } from '../../utils/functions';
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const DataAdmin: React.FC = () => {
  const { firmData } = UseFirmList();
  const endpoint = '/dataAdmin';

  const { 
    data, 
    totalCount, 
    fetchData, 
    setFilter, 
    sort, 
    setSort, 
    pagination, 
    setPagination,
    filter,
    inputFilters,
    setInputFilters
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    defaultSorting: { field: "person", order: "asc" },
  });

  const columnsDef = React.useMemo(() => [
    { 
      id: 'count', 
      header: '#', 
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p>{rowIndex + 1 + pagination.pageIndex * pagination.pageSize}</p>
      )
    },
    { id: 'firm', header: 'Firm' },
    { id: 'person', header: 'Person' },
    { id: 'dataAdminType', header: 'Data Admin Type' },
    { id: 'membershipLocation', header: 'MembershipLocation' },
    { id: 'createdDate', header: 'Created Date' },
    {
      id: 'edit', 
      header: 'Edit', 
      enableSorting: false,
      cell: ({ row, rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <PersistentLink
          className="edit"
          to={`Edit/${row.id}`}
          state={data[rowIndex]}
          persistingData={{
            pagination,
            sort,
            filter, 
            inputFilters, 
          }}
        >
          Edit
          <div className="editsvg"><ShapeEdit /></div>
        </PersistentLink>
      )
    },
  ], [pagination.pageIndex, pagination.pageSize, sort, filter, inputFilters, data]);

  const formatData = (data: any) => {
    const formatedData = data.map((d: any) => {
      return {
        ...d,
        firm: d.firmName,
        person: d.personName,
        membershipLocation: d.membershipLocationName,
        dataAdminType: d.type === 0 ? 'Primary' : d.type === 1 ? 'Dedicated' : '',
        createdDate: d.createdDate ? formatTimeSpanToString(d.createdDate) : ''
      }
    })
    return formatedData
  }

  const filtersData: IFilterData[] = React.useMemo(() => [
    {
      name: "Person",
      type: "text",
      comparison: "CONTAINS",
    },
    {
      name: "Firm",
      objectData: firmData?.map((f: any) => ({id: f.id, name: f.name})) || [],
    },
  ], [firmData]);

  return (
    <>
        <CatalogTableC
          title={`DataAdmin Catalog`} 
          catalogName={'DATA ADMINS'} 
          catalogShortName="DATA ADMIN"
          route={'DataAdmin'}
          totalCount={totalCount}
        >
          <Filters
            filtersData={filtersData} 
            filterValues={inputFilters}
            setFilterValues={setInputFilters} 
            Search={() => fetchData()}
            clearSelections={() => fetchData(true)}
            setValueForQuery={setFilter}
          />
          <PaginatedTable
            data={data || []}
            columnsDef={columnsDef}
            formatData={formatData}
            sorting={sort}
            onSortingChange={setSort}
            totalCount={totalCount || 0}
            pagination={pagination}
            onPaginationChange={setPagination}
            endpoint={endpoint}
            onExportAll={() =>
              exportAllDataLoader2<any>({
                endpoint,
                filter,
                sort,
                pageSize: 1000,
              })
            }
          />
        </CatalogTableC>
    </>
  );
};

export default DataAdmin;
